// Tracks the number of in-flight API requests. The console's RequestProgress
// component reads this (combined with SvelteKit's `navigating` store) to drive
// a top-bar loading indicator.
//
// Class pattern per Svelte's recommendation — aligns with the platformLimits
// / identity / toasts pattern for cross-component reactive singletons.

class RequestProgress {
  count = $state(0);

  start(): void {
    this.count++;
  }

  end(): void {
    this.count = Math.max(0, this.count - 1);
  }
}

export const requestProgress = new RequestProgress();
